import React from "react";
import { SWATCH_COLORS } from "./swatchColors";

interface SwatchColorPickerProps {
  value: string; // swatch name
  onChange: (swatchName: string) => void;
}

const SwatchColorPicker: React.FC<SwatchColorPickerProps> = ({
  value,
  onChange,
}) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(16, 1fr)",
        gap: 1,
        width: 320,
        maxHeight: 313,
        overflowY: "auto",
        border: "1px solid #f2f2f2",
        borderRadius: 6,
        backgroundColor: "#eee",
      }}
    >
      {SWATCH_COLORS.map((swatch) => (
        <div
          key={swatch.name}
          onClick={() => onChange(swatch.name)}
          style={{
            width: "100%",
            height: "20px",
            background: swatch.background,
            border: value === swatch.name ? "1px solid #000" : "0px solid #ccc",
            borderRadius: 4,
            cursor: "pointer",
            boxSizing: "border-box",
            transition: "border 0.2s",
          }}
          title={swatch.name}
        />
      ))}
    </div>
  );
};

export default SwatchColorPicker;
